/* eslint-disable */
import { css, unsafeCSS } from 'lit-element';
import { border_box as borderBox } from '@aab/sc-styles-grid';
import { p_1, p_0, mt_2 ,m_0, mt_1, mr_1, smr_2} from '@aab/sc-styles-spacing';
import {
  align_items_center, align_content_center, d_block,
  d_flex, d_table, flex_column, d_table_cell, d_table_row, d_none, flex_wrap,
  align_items_start, align_items_end, justify_content_center, text_center,
  shadow_card, rounded_2, position_absolute,
} from '@aab/sc-styles-utilities';

// box-sizing: border-box; (borderBox) is required in order to include padding and border in the width and height of an element
// the borderBox class makes sure the grid works and makes creating lay-outs easier and more intuitive
const styles = css`
    ${unsafeCSS(borderBox)}
    ${unsafeCSS(p_0)}
    ${unsafeCSS(p_1)}
    ${unsafeCSS(m_0)}
    ${unsafeCSS(mt_2)}
    ${unsafeCSS(mt_1)}
    ${unsafeCSS(mr_1)}
    ${unsafeCSS(smr_2)}
    ${unsafeCSS(align_items_center)}
    ${unsafeCSS(align_items_end)}
    ${unsafeCSS(align_content_center)}
    ${unsafeCSS(flex_column)}
    ${unsafeCSS(d_flex)}
    ${unsafeCSS(d_block)}
    ${unsafeCSS(d_table)}
    ${unsafeCSS(d_table_cell)}
    ${unsafeCSS(d_table_row)}
    ${unsafeCSS(d_none)}
    ${unsafeCSS(align_items_start)}
    ${unsafeCSS(justify_content_center)}
    ${unsafeCSS(flex_wrap)}
    ${unsafeCSS(text_center)}
    ${unsafeCSS(shadow_card)}
    ${unsafeCSS(rounded_2)}
    ${unsafeCSS(position_absolute)}
`;

export default styles;
